import React, { useState } from "react";
import LoadingSpinner from "./loadingSpinner";
import { navigate } from "gatsby";
import { __t } from "../../utils/translate";
import { SearchLogo } from "./searchModal";

type SearchInputProps = {
    className?: string;
    onClick?: () => void;
};

const SearchInput: React.FC<SearchInputProps> = ({
    className = "",
    onClick,
}) => {
    const [message, setMessage] = useState<string | undefined>();
    const [value, setValue] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue(event.target.value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (onClick) onClick();
        value !== ""
            ? navigate(`/shop?s=${encodeURIComponent(value)}`)
            : null
    };


    return (
        <>
            <form className={`${className} relative w-full h-10 lg:max-w-[517px]`} onSubmit={handleSubmit}>
                <input
                    className="font-system w-full border border-dark-blu/10 outline-none focus:placeholder:!opacity-0 placeholder:transition-all placeholder:duration-[0.7s] placeholder:ease-in-out rounded py-2 pl-14 pr-4 text-18 leading-[18px] bg-[#f8f8f8] opacity-40 placeholder:opacity-100 placeholder:pl-1 placeholder:!text-[#626262] placeholder:!font-normal"
                    type="text"
                    id="search-input"
                    placeholder={__t("Search products...")}
                    value={value}
                    onChange={onChange}
                />
                <label className="hidden" htmlFor="search-input">
                    {__t("Search for...")}
                </label>
                <button
                    aria-label="search sumbit"
                    type="submit"
                    className="absolute left-[22px] top-[10px]"
                >
                    {isLoading ? <LoadingSpinner /> :
                        <SearchLogo />
                    }
                </button>
            </form>
            {!!message && (
                <div className="text-primary-gray mt-[10px] text-sm">{message}</div>
            )}
        </>
    );
};

export default SearchInput;
